import React, { useContext, useState, useEffect } from 'react';
import { CONFIG } from 'config/config';
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import { isMobile } from 'react-device-detect';
import { NavigationWrapper, View } from '@coinscrap/webapp-core';

import logoAllianz from 'assets/images/logos/Allianz.svg';
import logoBmw from 'assets/images/logos/BMW_Grey.svg';
import logoBmwGroup from 'assets/images/logos/BMW_Group_Grey.svg';
import logoMini from 'assets/images/logos/Mini_Grey.svg';

import { AgentContext } from '../../../contexts/agent';
import * as S from './styles';

// Función para comprobar si estamos en horario de atención (Lunes a jueves: 9:00-19:00, Viernes: 9:00-18:00)
const isRastreatorWithinWorkingHours = () => {
	const now = new Date();
	const day = now.getDay(); // 0 = domingo, 1 = lunes, ..., 6 = sábado
	const hour = now.getHours();
	const minute = now.getMinutes();
	const currentTime = hour + minute / 60; // Convertir a formato decimal (ej: 9:30 = 9.5)

	// Lunes a jueves (día 1-4): 9:00 a 19:00
	if (day >= 1 && day <= 4) {
		return currentTime >= 9 && currentTime < 19;
	}

	// Viernes (día 5): 9:00 a 18:00
	if (day === 5) {
		return currentTime >= 9 && currentTime < 18;
	}

	// Sábado y domingo: fuera de horario
	return false;
};

const Header = ({ showButton = true }) => {
	const { agent } = useContext(AgentContext);
	const { navigateTo } = NavigationWrapper.use();

	return (
		<View headerSt>
			<View headerInnerSt>
				<View headerLogosSt>
					{agent.identifier === 'bmw' && (
						<>
							<S.LogoBmwGroup
								isMobile={isMobile}
								alt="Logo BMW Group"
								src={logoBmwGroup}
							/>
							<S.LogoBmw isMobile={isMobile} alt="Logo BMW" src={logoBmw} />
							<S.LogoMini isMobile={isMobile} alt="Logo Mini" src={logoMini} />
						</>
					)}
					{agent.identifier !== 'allianz' && <S.SeparadorImg />}
					<S.Logo
						isMobile={isMobile}
						alt="Logo Allianz"
						src={logoAllianz}
						extraLogos={agent.identifier !== 'allianz'}
					/>
				</View>

				<View headerButtonsSt>
					{CONFIG.layout.header.showContactButton.B2C &&
						showButton &&
						agent.identifier === 'allianz' && (
							<div
								className="c-header-metabar__target c-header__navigation"
								style={{
									display: agent.identifier === 'allianz' ? 'block' : 'none',
								}}
							>
								<div className="c-header-metabar__content"></div>
							</div>
						)}
					{CONFIG.layout.header.showContactButton.B2C &&
						showButton &&
						agent.identifier === 'bmw' && (
							<a
								href={`tel:${agent?.delioPhone ?? CONFIG.contactPhone.value}`}
								target="_blank"
								rel="noopener noreferrer"
								style={{ textDecoration: 'none' }}
							>
								<View
									rowSt
									alignItemsCenterSt
									style={{
										padding: '8px 12px',
										border: `1px solid ${CONFIG.colors.primary}`,
										borderRadius: '30px',
									}}
								>
									<LocalPhoneIcon
										style={{
											color: CONFIG.colors.primary,
											cursor: 'pointer',
											width: '16px',
											height: '16px',
											marginRight: '4px',
										}}
									/>
									<View
										style={{
											width: 'calc(100% - 20px)',
											color: `${CONFIG.colors.primary}`,
											whiteSpace: 'nowrap',
										}}
									>
										{`${agent?.delioPhoneText ?? CONFIG.contactPhone.label}`}
									</View>
								</View>
							</a>
						)}
					{CONFIG.layout.header.showContactButton.B2C &&
						showButton &&
						agent.identifier === 'rastreator' &&
						isRastreatorWithinWorkingHours() && (
							<a
								href={`tel:${agent?.delioPhone ?? CONFIG.contactPhone.value}`}
								target="_blank"
								rel="noopener noreferrer"
								style={{ textDecoration: 'none' }}
							>
								<View
									rowSt
									alignItemsCenterSt
									style={{
										padding: '8px 12px',
										border: `1px solid ${CONFIG.colors.primary}`,
										borderRadius: '30px',
									}}
								>
									<LocalPhoneIcon
										style={{
											color: CONFIG.colors.primary,
											cursor: 'pointer',
											width: '16px',
											height: '16px',
											marginRight: '4px',
										}}
									/>
									<View
										style={{
											width: 'calc(100% - 20px)',
											color: `${CONFIG.colors.primary}`,
											whiteSpace: 'nowrap',
										}}
									>
										{`${agent?.delioPhoneText ?? CONFIG.contactPhone.label}`}
									</View>
								</View>
							</a>
						)}
					{CONFIG.layout.header.showContactButton.B2C &&
						showButton &&
						agent.identifier === 'rastreator' &&
						!isRastreatorWithinWorkingHours() && (
							<button
								onClick={() => {
									console.log('Call me back clicked');
									CONFIG.routing.autolanding.contact(navigateTo);
								}}
								style={{
									padding: '8px 12px',
									border: `1px solid ${CONFIG.colors.primary}`,
									borderRadius: '30px',
									background: 'transparent',
									cursor: 'pointer',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<View rowSt alignItemsCenterSt>
									<LocalPhoneIcon
										style={{
											color: CONFIG.colors.primary,
											cursor: 'pointer',
											width: '16px',
											height: '16px',
											marginRight: '4px',
										}}
									/>
									<View
										style={{
											width: 'calc(100% - 20px)',
											color: `${CONFIG.colors.primary}`,
											whiteSpace: 'nowrap',
										}}
									>
										Contactar
									</View>
								</View>
							</button>
						)}
					{CONFIG.layout.header.showLangSelector.B2C && showButton && null}
				</View>
			</View>
		</View>
	);
};

export default Header;
